import React from 'react';
import Toast from './Toast';
import {useToastStore} from 'store/toast';

export default function GlobalToast() {
    const {isVisible, message, duration, autoClose, hideToast} = useToastStore();

    return (
        <Toast message={message} isVisible={isVisible} onClose={hideToast} duration={duration} autoClose={autoClose} />
    );
}
